import React from 'react'
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@material-ui/core'
import clsx from 'clsx'
import { useFormikContext } from 'formik'
import {
  CHAMPIONSHIP_TYPES,
  LAP_PERCENTAGE_REQUIRED_MAX,
  LAP_PERCENTAGE_REQUIRED_MIN
} from 'utils/constants'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './StateSection.style'

const StateSection = () => {
  const classes = useStyles()

  const { values, errors, touched, handleBlur, setValues } = useFormikContext()

  const CHAMPIONSHIP_TYPES_OPTIONS = Object.values(CHAMPIONSHIP_TYPES)

  const handleChangeType = (e) => {
    const championshipPointsSelected = e.target.value === CHAMPIONSHIP_TYPES.POINTS.value

    setValues((values) => ({
      ...values,
      [e.target.name]: e.target.value,
      minLapPercentageRequired: championshipPointsSelected
        ? LAP_PERCENTAGE_REQUIRED_MAX
        : LAP_PERCENTAGE_REQUIRED_MIN
    }))
  }

  return (
    <SectionBlock title='Estado del campeonato'>
      <div className={classes.formGroup}>
        <FormControl fullWidth variant='outlined'>
          <InputLabel
            id='championship-simple'
            className={clsx(classes.labelSelect, touched.type && errors.type && 'error')}>
            Tipo de campeonato*
          </InputLabel>
          <Select
            className={classes.select}
            value={values.type}
            required
            error={Boolean(errors.type) && touched.type}
            onBlur={handleBlur}
            name='type'
            onChange={handleChangeType}
            color='primary'
            variant='outlined'
            labelId='championship-simple'
            label='Tipo de campeonato*'>
            {CHAMPIONSHIP_TYPES_OPTIONS.map((x) => (
              <MenuItem value={x.value} key={x.value}>
                {x.label}
              </MenuItem>
            ))}
          </Select>

          {errors.type && (
            <Typography
              color={touched.type ? 'error' : 'inherit'}
              className={classes.altErrorMessage}>
              {errors.type}
            </Typography>
          )}
        </FormControl>
      </div>
    </SectionBlock>
  )
}

export default StateSection
